import { GetServerSideProps } from "next";
import { ReactElement } from "react";
import TepezzaWrapper from "@components/layouts/tepezzaWrapper";

import { getPageProps } from "@services/initial-calls";
import PrivacyPolicy from "@components/shared/legal/privacyPolicy";

export default function TepezzaHome(): ReactElement {
    return (
        <TepezzaWrapper>
            <div className="w-full max-w-7xl mx-auto">
                <PrivacyPolicy category="Tepezza" domain="Tepezza.Claims" />
            </div>
        </TepezzaWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", { pageTitle: "Privacy Policy" });
};
